const ListItemGetterService = require('./ListItemGetterService');
const merge = require('deepmerge');

class IntegratedBanksService {
  static isBankIntegrated({ bankId, bankCode, transfeeraBankAccounts }) {
    const banks = IntegratedBanksService.getFromTransfeeraBankAccounts(transfeeraBankAccounts);

    if (bankId) {
      return Boolean(
        ListItemGetterService.getByProp({
          propValue: bankId,
          propName: 'id',
          list: banks
        })
      );
    }

    return Boolean(
      ListItemGetterService.getByProp({
        propValue: bankCode,
        propName: 'code',
        list: banks
      })
    );
  }

  static getFromTransfeeraBankAccounts(transfeeraBankAccounts) {
    const banks = [];
    if (Array.isArray(transfeeraBankAccounts)) {
      transfeeraBankAccounts.forEach(transfeeraBankAccount => {
        const bank = merge({}, transfeeraBankAccount.Bank);
        banks.push(bank);
      });
    } else if (transfeeraBankAccounts && typeof transfeeraBankAccounts === 'object') {
      Object.keys(transfeeraBankAccounts).forEach(bankAccount => {
        const bank = merge({}, transfeeraBankAccounts[bankAccount]);
        banks.push(bank);
      });
    }
    return banks;
  }
}

module.exports = IntegratedBanksService;
